module.exports = __webpack_public_path__ + "images/169_2048.jpg";